import script from "./fromThirdPay.vue?vue&type=script&setup=true&lang=js"
export * from "./fromThirdPay.vue?vue&type=script&setup=true&lang=js"

import "./fromThirdPay.vue?vue&type=style&index=0&id=610b5e8d&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610b5e8d"]])

export default __exports__